module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAYFBMVEUAAABAgIBMqJ1KpZpOpZ1Ppp5OpZ5Opp5OpZ5Opp5Ppp1OpZ5Ppp5UqKBUqKFcrKVcraVfrqeIw72Iw76LxL+NxcCbzMiczcjb7evd7uze7uzg7+7r9fT2+vr5/Pz///845kuMAAAADHRSTlMABC8wl5vDw9fX8/cBYeXAAAAAk0lEQVQYGQXBCY6DMBAAME8OSPv/n65UEJOQtQNKadWa74sg2gm41xaiH/Epx8732k/uph19HMSp3t7Z6hnftq6pj8McV63te66/3HvO3uUqXfFbMG9FL8VhAamLAgBQXo8OHNIu6TUq1NMra/TVWrfL+Nb87Qxt9E8HeeU9qx0yVtnP/K2cgqgDcK8toEYPO/fCPyliSjizwYPWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/step.png
// module id = Q/0R
// module chunks = 1